module.exports = __webpack_public_path__ + "img/uefa.70216835.png";